import React from "react";
import DecisionReviewPointStop from "../../scoreboard-content/review/bottom/DecisionReviewPointStop";
import { useStyles } from "../ScoreboardStyles.css";

const ScoreboardBottomReviewPointStop = ({
    handleReplayScene,
    handleChangeActiveDecision,
    time,
    sessionInfo,
    feedbackMode,
    decisions,
    activeStep,
    endRun
}) => {
    const classes = useStyles();
    return (
        <div className={classes.scoreboardContainer}>
            <DecisionReviewPointStop
                handleReplayScene={handleReplayScene}
                handleChangeActiveDecision={handleChangeActiveDecision}
                time={time}
                sessionInfo={sessionInfo}
                feedbackMode={feedbackMode}
                decisions={decisions}
                activeStep={activeStep}
                endRun={endRun}
            />
        </div>
    );
};

export default ScoreboardBottomReviewPointStop;
